import { hasMacOSKbd } from '@fabric-app/utils/detection';
import { useKeyboardMapStore } from '../../keyboardShortcuts/hooks/useKeyboardMap.js';
import { keyToDisplayValue } from '../../keyboardShortcuts/modifierKeys.js';
import { useMemo } from 'react';

const isMac = hasMacOSKbd();
const useLayoutToPhysicalMapper = () => {
  const keyboardMap = useKeyboardMapStore((state) => state.keyToCodeMap);
  return useMemo(() => keyboardMap ? (keys) => {
    return keys.map((key) => {
      return (keyboardMap.get(key.toLowerCase()) || key).replace(/Key|Digit/g, "");
    });
  } : void 0, [
    keyboardMap
  ]);
};
const defaultAccelerators = {
  quickSearch: isMac ? [
    "Meta",
    "Alt",
    "F"
  ] : [
    "Control",
    "Alt",
    "F"
  ],
  quickNote: isMac ? [
    "Meta",
    "Alt",
    "N"
  ] : [
    "Control",
    "Alt",
    "N"
  ]
};
const useDefaultAccelerators = () => {
  const mapper = useLayoutToPhysicalMapper();
  const res = useMemo(() => Object.entries(defaultAccelerators).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: {
        displayStr: value.map((key2) => keyToDisplayValue(key2)).join(" + "),
        accelerator: (mapper ? mapper(value) : value).join("+")
      }
    };
  }, {}), [
    mapper
  ]);
  return res;
};

export { useDefaultAccelerators };
//# sourceMappingURL=useDefaultAccelerators.js.map
